$.fn.toggleHtml = function (t1, t2) {
  if (this.html() == t1) this.html(t2);
  else this.html(t1);
  return this;
};

$.fn.isOnScreen = function () {
  var win = $(window);

  var viewport = {
    top: win.scrollTop(),
    left: win.scrollLeft()
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();

  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();

  return !(
    viewport.right < bounds.left ||
    viewport.left > bounds.right ||
    viewport.bottom < bounds.top ||
    viewport.top > bounds.bottom
  );
};

$(document).ready(function () {
  applyColumns();

  var container = $("[data-pdp-colors]");
  if (container.length > 0) {
    var tags = container.attr("data-tags")
      ? container.attr("data-tags").split(",")
      : [];
    var product_id = container.attr("data-product-id")
      ? container.attr("data-product-id")
      : false;

    loadColorsByTags(
      tags,
      product_id,
      container.find("[data-pdp-colors]"),
      "product"
    );
  }

  $("body").on("click", ".popup", function (e) {
    if (e.target !== this) return;
    app.popup = false;
  });

  $("body").on("click", ".standard-form .btn--submit", function (e) {
    var cur = $(this);
    var form = cur.closest("form");
    var requiredFields = form.find("input[required], textarea[required]");
    var error = checkRequiredFields(requiredFields);
    if (!error) {
      form.addClass("ready");
      form.submit();
    }
    return false;
  });

  $(".standard-form input").on("blur", function () {
    if ($(this).attr("required")) {
      var error = checkRequiredFields([$(this)]);
    }
  });

  $(".slider-nav li a").on("click", function () {
    var cur = $(this);
    var slider = cur.closest(".slider-block").find(".owl-carousel");
    var way = cur.closest("li").data("way");
    slider.trigger(way + ".owl.carousel");
  });

  $.get(createUrl("category-1/?smformat=json"), function (data) {});

  window.LS_theme = {
    developer: "Shopmonkey",
    name: "__CUSTOM SHOP NAAM__",
    docs: "Sent by e-mail, ask Shopmonkey."
  };

  $(".vue-add-live").on("click", function () {
    var cur = $(this);
    var form = cur.closest("form");
    var product_url = cur.data("product-url");
    var url = cur.hasClass("productpage")
      ? form.attr("action")
      : cur.data("url");
    var formData = cur.hasClass("productpage") ? form.serialize() : "";
    var btn = cur;
    var btnText = btn.html();

    $.ajax({
      type: "POST",
      data: formData,
      url: url
    }).done(function (data) {
      $.get(basicUrl + "?format=json", function (data) {
        app.page = data.page;
      }).done(function () {
        if (product_url) {
          $.get(product_url + "?format=json", function (data) {
            app.added_to_cart = data.product;
          });
        }
      });
      createMessage(data, "add", btn, btnText);
    });
  });

  // Fancybox //
  $("[data-fancybox]").fancybox({
    mobile: {
      clickSlide: "close"
    },
    touch: false //------ ALWAYS ON TOP! ------//
  });
  // End fancybox //

  $(".custom-select, .product-configure select").dropdown(); //------ SEMANTIC DROPDOWN ------//

  // Scroll to div //
  $("[data-scroll]").on("click", function () {
    var element = $(this).data("scroll");
    var headerHeight =
      $(".topbar").outerHeight() + $(".main-menu").outerHeight();
    $("html, body").animate(
      {
        scrollTop: $(element).offset().top - headerHeight - 100
      },
      "fast"
    );
  });
  // End scroll to div //

  // Accordion //
  $("[data-sm-accordion-toggle]").on("click", function () {
    var cur = $(this);
    if (cur.closest("[data-sm-accordion-tab]").hasClass("active")) {
      cur
        .closest("[data-sm-accordion-tab]")
        .removeClass("active")
        .find("[data-sm-accordion-content]")
        .slideUp();
    } else {
      cur
        .closest("[data-sm-accordion]")
        .find("[data-sm-accordion-tab].active")
        .removeClass("active")
        .find("[data-sm-accordion-content]")
        .slideUp();
      cur
        .closest("[data-sm-accordion-tab]")
        .addClass("active")
        .find("[data-sm-accordion-content]")
        .slideDown();
    }
  });
  // End accordion //

  // Tabs //
  $("[data-sm-tab-link]").on("click", function () {
    var cur = $(this);
    var index = cur.data("index");
    if (!cur.closest("li").hasClass("active")) {
      cur
        .closest("[data-sm-tabs]")
        .find(".tab-links li.active")
        .removeClass("active");
      cur.closest("[data-sm-tabs]").find(".page.active").removeClass("active");
      cur.closest("li").addClass("active");
      cur
        .closest("[data-sm-tabs]")
        .find(".page.page-" + index + "")
        .addClass("active");
    }
  });
  // End tabs //

  // Header fixed //
  // headerFixed();
  // $(window).scroll(function () {
  //   headerFixed();
  // });
  // End header fixed //

  $("#header .main-nav > li.with-subs").on("mouseenter", function () {
    $(".menu-overlay").addClass("active");
  });
  $("#header .main-nav > li").on("mouseleave", function () {
    $(".menu-overlay").removeClass("active");
  });

  // Topbar usp //
  $(".topbar-usp").on("initialized.owl.carousel", function () {
    $(this).removeClass("slider-loading");
  });
  // End topbar usp //

  // Messages //
  setTimeout(function () {
    $(".message-wrap:not(.live-message)").removeClass("active");
  }, 4000);
  // End messages //

  // Mobile menu //
  $(".open-menu").on("click", function () {
    $(".body-wrap, .mobile-menu, .mobile-menu-overlay").toggleClass(
      "mobile-menu-open"
    );
    $(this).toggleClass("active");
    $("html").toggleClass("no-scroll");
  });

  $(".mobile-menu-overlay, .mobile-menu a[data-fancybox], a.open-wishlist").on(
    "click",
    function () {
      $(".body-wrap, .mobile-menu, .mobile-menu-overlay").removeClass(
        "mobile-menu-open"
      );
      $(".open-menu").removeClass("active");
      $("html").removeClass("no-scroll");
    }
  );

  $(".mobile-menu ul li .more-cats").on("click", function () {
    var cur = $(this);
    if (!cur.closest("li").hasClass("active")) {
      cur.closest("ul").find("li").removeClass("active");
      cur.closest("ul").find("li ul").slideUp(200);
      cur.closest("li").addClass("active");
      cur.closest("li").find(">ul").slideDown(200);
    } else {
      cur.closest("li").removeClass("active");
      cur.closest("li").find(">ul").slideUp(200);
    }
  });
  // End mobile menu //

  // Products //
  $(window).scroll(function () {
    var productIndex = 0;
    $(".products .product, .products .product-list").each(function () {
      var cur = $(this);
      if (cur.isOnScreen()) {
        productIndex++;
        loadProduct(cur, productIndex);
      }
    });
  });

  $(".products .product").each(function (index, product) {
    var cur = $(this);
    if (cur.isOnScreen()) {
      loadProduct(cur, index);
    }
  });

  $(".products-slider")
    .on("initialized.owl.carousel", function () {
      $(".products-slider")
        .find(".product")
        .each(function () {
          loadProduct($(this));
        });
    })
    .on("translated.owl.carousel", function () {
      $(".products-slider")
        .find(".product")
        .each(function () {
          loadProduct($(this));
        });
    })
    .owlCarousel({
      loop: true,
      autoplay: true,
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        992: {
          items: 2
        },
        1200: {
          items: 3
        }
      }
    });

  $(".product__slider").owlCarousel({
    margin: 0,
    autoplay: false,
    items: 1,
    loop: false,
    dots: false,
    nav: true,
    navText: [
      '<i class="bx bx-chevron-left" ></i>',
      '<i class="bx bx-chevron-right" ></i>'
    ]
  });

  // End products  //

  // Productpage //
  $(".productpage-slider")
    .on("initialized.owl.carousel", function () {
      $(".productpage-slider-outer").removeClass("slider-loading");
    })
    .owlCarousel({
      margin: 0,
      autoplay: false,
      items: 1,
      loop: false,
      dots: false,
      nav: true,
      navText: [
        '<i class="zwicon-chevron-left"></i>',
        '<i class="zwicon-chevron-right"></i>'
      ]
    });

  $(".thumbs .thumb").on("click", function () {
    var imageIndex = $(this).data("index");
    $(".productpage-slider").trigger("to.owl.carousel", imageIndex);
    $("#productpage .thumbs .thumb").removeClass("active");
    $(this).addClass("active");
  });

  $(".productpage-slider").on("translated.owl.carousel", function (event) {
    var imageIndex = $(this).find(".owl-item.active .image-wrap").data("index");
    $("#productpage .thumbs .thumb").removeClass("active");
    $('.thumb[data-index="' + imageIndex + '"]').addClass("active");
  });

  if ($("[data-linked-products]").length > 0) {
    var optionsWrap = $("[data-linked-products]").find(".linked-options");
    var url = $("[data-linked-products]").data("search-url");
    var curID = $("[data-linked-products]").data("cur-id");
    var prevUrl = $("[data-linked-products]").data("prev-url");
    var curVal = $("[data-linked-products]").data("cur-val");
    var loadBy = $("[data-linked-products]").data("load-by");
    var count = 0;
    $.get(url + "?format=json", function (data) {
      var collection = data.collection;
      $.each(collection.products, function (index, product) {
        count++;
        var html = "";
        if (product[loadBy] == curVal) {
          html +=
            '<div class="option' +
            (product.id == curID ? " active" : "") +
            '">';
          html +=
            '<a href="' +
            createUrl(product.url) +
            '" title="' +
            product.title +
            '">';
          html += '<div class="image-wrap">';
          html +=
            '<img src="' +
            createImage(product.image, "100x100x2") +
            '" alt="' +
            product.fulltitle +
            '" title="' +
            product.title +
            '">';
          html += "</div>";
          html += "</a>";
          html += "</div>";
          optionsWrap.append(html);
        }
      });
    }).done(function () {
      if (count > 1) {
        $("[data-linked-products]").removeClass("d-none");
        setTimeout(function () {
          optionsWrap.find(".dummy").remove();
          optionsWrap.removeClass("loading");
        }, 500);

        $.get(prevUrl + "?format=json", function () {});
      }
    });
  }
  // End productpage //

  // collection //
  $(".toggle-filters").on("click", function () {
    $("html, body").addClass("no-scroll");
    $(".sidebar, .sidebar-overlay").addClass("active");
  });

  $(".sidebar-overlay, .close-sidebar").on("click", function () {
    $("html, body").removeClass("no-scroll");
    $(".sidebar, .sidebar-overlay").removeClass("active");
  });
  // End collection //

  // Cart //
  $('#cart-page input[name="updates[]"]').on("change", function () {
    var cur = $(this);
    setTimeout(function () {
      cur.closest("form").submit();
    }, 1000);
  });
  // End cart //

  attachWishlistCountClicks();
}); // End document ready

$(window).load(function () {
  sizing();
});
$(window).resize(function () {
  sizing();
});

// function createUrl(url) {
//   url = basicUrl+url;
//   return url;
// }

function addToCart(event, variantID) {
  app.addToCart(event, variantID);
}

function loadMoreContinue() {
  if (!window.location.href.includes("#")) {
    return;
  }

  const products = document.querySelector(".products");
  let currentPage = parseInt(window.location.href.split("#")[1]);

  if (currentPage > products.dataset.allPages) {
    return;
  }

  let dataSet = document.querySelector(".products").dataset;
  let datacollurl = dataSet.collUrl;
  let current_page_new = parseInt(currentPage + 1);
  let nextUrl = datacollurl + "?page=" + currentPage;
  let next_coll = parseInt(currentPage + 2);
  let resultHTML = null;

  for (let i = 2; i <= currentPage; i++) {
    let nextUrl = datacollurl + "?page=" + i;
    //clearTimeout(timeout);

    //timeout = setTimeout(() => {

    $.ajax({
      url: nextUrl,
      type: "GET",
      dataType: "html",
      async: false,
      beforeSend: () => {
        document.querySelector(".js-load-button").innerText = "Loading...";
      },
      success: (responseHTML) => {
        const allLoadMoreButtons = document.querySelectorAll(".js-load-button");
        if (allLoadMoreButtons.length > 0) {
          allLoadMoreButtons.forEach((button) => button.parentElement.remove());
        }
        nextUrl = datacollurl + "?page=" + current_page_new;
        $(".products").append($(responseHTML).find(".products").html());
      }
    });
    //}, 1000 * i);
  }
}

loadMoreContinue();

function loadMore(e) {
  let currentPage = null;

  if (!window.location.href.includes("#")) {
    currentPage = 1;
  } else {
    currentPage = parseInt(window.location.href.split("#")[1]);
  }

  const currentUrlParams = new URLSearchParams(
    document.location.search
  ).toString();
  let dataSet = document.querySelector(".products").dataset;
  let datacollurl = dataSet.collUrl;
  let current_page_new = parseInt(currentPage + 1);
  let nextUrl = datacollurl + "?page=" + current_page_new;
  let next_coll = parseInt(currentPage + 2);

  $.ajax({
    url: nextUrl,
    type: "GET",
    dataType: "html",
    beforeSend: () => {
      e.target.innerText = "Loading...";
    },
    success: (responseHTML) => {
      e.target.parentElement.remove();
      nextUrl = datacollurl + "?page=" + next_coll;
      $(".products").append($(responseHTML).find(".products").html());

      $(".product__slider").owlCarousel({
        margin: 0,
        autoplay: false,
        items: 1,
        loop: false,
        dots: false,
        nav: true,
        navText: [
          '<i class="bx bx-chevron-left" ></i>',
          '<i class="bx bx-chevron-right" ></i>'
        ]
      });

      if (currentUrlParams !== "") {
        applyColumns();
        window.location = `${datacollurl}?${currentUrlParams}#${current_page_new}`;
      } else {
        window.location = `${datacollurl}#${current_page_new}`;
      }

      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

      window.SwymCallbacks.push(swymNotifyMeCallback);
      window.SwymCallbacks.push(swymWishlistCallback);
      attachWishlistCountClicks();
    }
  });
}

function swymNotifyMeCallback(swat) {
  // your API calls go here
  attachNotifyMeEvents();
  function attachNotifyMeEvents() {
    var swymNotifyMeBtn = document.querySelectorAll(
      ".swym-custom-watchlist:not(.swym-loaded)"
    );
    swymNotifyMeBtn.forEach(function (btn) {
      btn.addEventListener("click", addToWatchlist);
      btn.classList.add("swym-loaded");
    });
  }
  function addToWatchlist(eventObj) {
    eventObj.preventDefault();
    var productId = +eventObj.target.getAttribute("data-product-id");
    var variantId = +eventObj.target.getAttribute("data-variant-id");
    var du = eventObj.target.getAttribute("data-url");
    var params = {
      empi: productId,
      epi: variantId,
      du: du
    };
    swat.getProductDetails(params, function (productJSON) {
      productJSON.variants.forEach(function (v) {
        if (v.id == variantId) {
          params.pr = SwymUtils.formatProductPrice(v.price);
          params.iu = productJSON.featured_image;
          params.et = 8;
          swat.addToWatchList(eventObj, params, function (e) {
            //console.log("Subscribed to product!", e);
          }); // Shows Subscribe me.
          return;
        }
      });
    });
  }
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymNotifyMeCallback);

function swymWishlistCallback(swat) {
  // your API calls go here
  document.addEventListener("swym:collections-loaded", function () {
    swat.initializeActionButtons(".products");
  });
}

window.SwymCallbacks.push(swymWishlistCallback);

function swymUpdateWishlistCountCallback(swat) {
  document.addEventListener("swym:click-heart", () => {
    const countContainer = document.getElementById("wishlist-count");
    var wishlistCount = 0;
    swat.fetch((products) => {
      wishlistCount = products.length;
      countContainer.innerHTML = wishlistCount;
    });
  });
}

window.SwymCallbacks.push(swymUpdateWishlistCountCallback);

var timeout = null;

function attachWishlistCountClicks() {
  const buttons = document.querySelectorAll(
    ".swym-add-to-wishlist-view-product:not(.custom-event-attached)"
  );

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      timeout = setTimeout(() => {
        document.dispatchEvent(new CustomEvent("swym:click-heart"));
      }, 1000);
    });

    button.classList.add("custom-event-attached");
  });
}

function createUrlAssets(url) {
  url = assetsUrl + url;
  return url;
}

function createImage(url, format) {
  var formats = format.split("x");
  var width = formats[0] ? formats[0] : false;
  var height = formats[1] ? formats[1] : false;

  if (url.indexOf("?") >= 0) {
    url += "&";
  } else {
    url += "?";
  }
  url += "crop=center";
  if (width) {
    url += "&width=" + width;
  }
  if (height) {
    url += "&height=" + height;
  }

  return url;
}

function sizing() {
  var windowWidth = $(window).width();

  if (windowWidth < 1200) {
    $(".topbar-usp")
      .addClass("owl-carousel")
      .owlCarousel({
        autoplay: true,
        loop: true,
        dots: false,
        nav: false,
        responsive: {
          0: {
            items: 1
          },
          992: {
            items: 2
          }
        }
      });
  } else {
    $(".topbar-usp")
      .removeClass("owl-carousel")
      .trigger("destroy.owl.carousel");
  }
}

function pad(str, max) {
  str = str.toString();
  return str.length < max ? pad("0" + str, max) : str;
}

function updateQuantity(way, cur) {
  var quantity = parseInt(cur.closest(".input-wrap").find("input").val());

  if (way == "up") {
    quantity++;
  } else {
    if (quantity > 1) {
      quantity--;
    }
  }

  cur.closest(".input-wrap").find("input").val(quantity).trigger("change");
  cur
    .closest(".input-wrap")
    .find("input")[0]
    .dispatchEvent(new CustomEvent("input"));
}

function money(price) {
  if (price) {
    price = price / 100;
    price = parseFloat(price).toFixed(2);
    price += "";
    // var shopCurrency = '';
    var x = price.split(".");
    var x1 = x[0];
    var x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    var x3 = (x1 + x2).split(".");
    var x4 = x3[0].replace(",", ".") + "," + x3[1];
    var priceMoney = shopCurrency + "" + x4;
    if (shopCurrency == "$") {
      priceMoney = priceMoney.replace(",", ".");
    }
  } else {
    var priceMoney = "";
  }
  return priceMoney;
}

var infiniteCollectionPageAvailable = false;
var infiniteCollectionPageManual = false;
var infiniteCollectionPage = 1;
var infiniteCollectionBusy = false;
var infiniteCollectionRemaining = 0;

function infiniteInit(url, page, mode) {
  infiniteCollectionPageAvailable = true;

  // load more blog articles
  $(".blog-spinner-more").click(function () {
    infiniteBlogLoad(url, mode);
    return false;
  });

  // // if collection infinite reloaded
  // var currentUrl = window.location.href;
  // var scrolledPage = currentUrl.split('#');
  // scrolledPage = scrolledPage[1] ? scrolledPage[1] : false ;
  // if (scrolledPage) {
  //     infiniteCollectionLoad(url, mode);
  // }

  $(document).scroll(function () {
    if (infiniteCollectionPageAvailable && !infiniteCollectionPageManual) {
      if ($(".collection-spinner").length > 0) {
        var offsetFromScreen =
          $(window).height() +
          $(window).scrollTop() -
          $(".collection-spinner").offset().top;

        if (offsetFromScreen > -100) {
          infiniteCollectionLoad(url, mode, "click");
        }
      }

      if ($(".blog-spinner").length > 0) {
        var offsetFromScreen =
          $(window).height() +
          $(window).scrollTop() -
          $(".blog-spinner").offset().top;

        if (offsetFromScreen > -100 && !infiniteCollectionBusy) {
          infiniteCollectionPage++;
          url = url.replace(
            "page1.ajax",
            "page" + infiniteCollectionPage + ".html?format=json"
          );
          infiniteBlogLoad(url, mode);
          infiniteCollectionBusy = true;
        }
      }
    }
  });
  $(document).scroll();
}

function infiniteBlogLoad(url, mode) {
  if (!infiniteCollectionBusy) {
    infiniteCollectionBusy = true;
    $(".blog-spinner").addClass("busy");
    infiniteCollectionPage++;
    url = url.replace(
      "page1.ajax",
      "page" + infiniteCollectionPage + ".html?format=json"
    );
    $.getJSON(url, function (json) {
      if (json.blog.articles) {
        infiniteCollectionRemaining = 5 - json.blog.pagination.page * 5;

        if (infiniteCollectionRemaining < 5) {
          $(".blog-spinner-more span").text(infiniteCollectionRemaining);
        }

        if (json.blog.pagination.pages <= infiniteCollectionPage) {
          infiniteCollectionPageAvailable = false;
          $(".blog-spinner").remove();
        }

        if (infiniteCollectionPage > 100) {
          infiniteCollectionPageManual = true;
          $(".blog-spinner").addClass("manual");
        }

        var counter = 1;

        var sortArticles = {};
        var count = 1;

        $.each(json.blog.articles, function (index, article) {
          var thisDate = Date.parse(article.date);
          sortArticles[thisDate] = article;
        });

        $.each(sortArticles, function (index, article) {
          var container = $(".blog-articles.inf-articles");
          var articleCol = container.data("articlecol");
          var html = "";

          var summary = article.summary;
          if (summary.length > 100) {
            summary = summary.substring(0, 100) + "... ";
          }

          html += '<div class="blog-article ' + articleCol + '">';
          html += '<div class="inner">';
          html +=
            '<a class="image-wrap" href="' + createUrl(article.url) + '">';
          html +=
            '<div class="image"><img src="' +
            createImage(article.image, "500x300x1") +
            '"></div>';
          html += "</a>";
          html += '<div class="info">';
          html +=
            '<a href="' +
            createUrl(article.url) +
            '" class="title title-font">' +
            article.title +
            "</a>";
          if (article.summary) {
            html += '<div class="summary">';
            html +=
              '<span class="content general-content line-height d-none d-sm-block">' +
              summary +
              "</span>";
            html +=
              '<a class="read-more" href="' +
              createUrl(article.url) +
              '">' +
              ajaxTranslations["Read more"] +
              "</a>";
            html += "</div>";
          }
          html += "</div>";
          html += "</div>";
          html += "</div>";

          /*
            html += '<div class="blog-article '+articleCol+'">';
              html += '<div class="inner">';
                html += '<a class="image-wrap" href="'+ createUrl(article.url) +'">';
                html += '<div class="image" style="background: url('+createImage(article.image)+') #f7f7f7 no-repeat center center; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover;"></div>';
                html += '</a>';
                html += '<div class="info">';
                html += '<a href="'+ createUrl(article.url) +'" class="title title-font">'+article.title+'</a>';
          
                html += '<div class="date-author">';
                  if (article.author) {
                    html += '<div class="author">'+ajaxTranslations['By']+' <span>'+article.author+'</span></div>';
                  }
                  html += '<div class="date"><i class="bx bx-time"></i>'+dayjs(article.date).format('D')+' '+ajaxTranslations[dayjs(article.date).format('MMMM')]+' '+dayjs(article.date).format('YYYY')+'</div>';
                html += '</div>';
          
                html += '<div class="summary">';
                  html += '<span class="content hidden-xs">';
                  html += summary;
                  html += '</span>';
                  html += '<a class="read-more" href="'+ createUrl(article.url) +'">'+ajaxTranslations['Read more']+'</a>';
                html += '</div>';
              html += '</div>';
                
              html += '</div>';
            html += '</div>';*/

          container.append(html);
          // var $html = $(html);
          // container.append($html).masonry( 'appended', $html );

          counter++;
        });
      }

      infiniteCollectionBusy = false;
      $(".collection-spinner").removeClass("busy");
      $(document).scroll();
    });
  }
}

function infiniteCollectionLoad(url, mode, type) {
  if (!infiniteCollectionBusy) {
    var currentUrl = window.location.href;
    var scrolledPage = currentUrl.split("#");
    scrolledPage = scrolledPage[1] ? scrolledPage[1] : false;

    if (type == "click") {
      infiniteCollectionBusy = true;
      $(".collection-spinner").addClass("busy");
      infiniteCollectionPage++;
      if (infiniteCollectionPage <= infiniteCollectionMax) {
        loadInfinitePage(url, type, infiniteCollectionPage);
      }
    }
    if (type == "pageload" && scrolledPage) {
      infiniteCollectionBusy = true;
      $(".collection-spinner").addClass("busy");

      for (i = 1; i < scrolledPage; i++) {
        infiniteCollectionPage++;
        loadInfinitePage(url, type, infiniteCollectionPage);
      }
    }
  }
}

function loadInfinitePage(url, type, infiniteCollectionPage) {
  url = url.replace("page1.ajax", "page" + infiniteCollectionPage + ".ajax");

  $.getJSON(url, function (json) {
    if (json.products) {
      var infiniteCollectionViewed = json.page * json.limit;
      var infiniteCollectionTotal = $("#collection").attr(
        "data-total-products"
      );
      infiniteCollectionTotal = parseFloat(infiniteCollectionTotal);
      var percentage =
        (infiniteCollectionViewed / infiniteCollectionTotal) * 100;

      $(".collection-spinner .status .bar").css("width", percentage + "%");

      //Push page number in url and set scroll position in history
      if (type == "click") {
        history.pushState(
          {
            scroll: $(window).scrollTop()
          },
          "",
          "#" + json.page
        );
      }

      // update counts
      $("#collection").attr("data-loaded-till", json.page);
      $(".collection-viewed-count span.viewed").text(infiniteCollectionViewed);

      if (json.pages <= infiniteCollectionPage) {
        infiniteCollectionPageAvailable = false;
        $(".collection-spinner").remove();
      }

      var counter = 1;
      $.each(json.products, function (index, product) {
        loadInfiniteProduct(product, counter);
      });
    }

    infiniteCollectionBusy = false;
    $(".collection-spinner").removeClass("busy");
    $(document).scroll();
  });
}

function loadInfiniteProduct(product, counter) {
  var infiniteUrl = product.url + "?format=json";
  var wishlistUrl =
    basicUrl +
    "account/wishlistAdd/" +
    product.id +
    "/?variant_id=" +
    product.vid;
  var cartUrl = basicUrl + "cart/add/" + product.vid + "/";
  var productType = $(".products")
    .find(".product")
    .first()
    .data("product-type");
  var container = $(".products");
  var productWrap = $("<div>")
    .append($(".products").find(".inf-product").first().clone())
    .html()
    .replace("inf_id_here", product.id)
    .replace("img-loaded", "")
    .replace("has-sec", "")
    .replace("product-hovered", "")
    .replace("product-loaded", "")
    .replace("inf-product", "inf-product inf-loading");
  container.append(productWrap);
  var productObject = $(".products").find(
    '.inf-product[data-inf-id="' + product.id + '"]'
  );

  // image settings
  var imageRatio = productObject
    .find("[data-inf-image]")
    .attr("data-inf-image");
  if (product.image) {
    var imageUrl = product.image.replace("50x50x2", imageRatio);
  } else {
    var imageUrl = "http://via.placeholder.com/500x800/ffffff/000000";
  }
  var plainImage = product.image.replace("/50x50x2/", "/");

  // percentage sale label
  if (product.price.price_old) {
    var discount =
      ((product.price.price - product.price.price_old) /
        product.price.price_old) *
      -100;
    discount = Math.round(discount, 0) + "%";
  } else {
    var discount = "";
  }

  // custom labels
  if (product.data_01) {
    var label = [];
    var data = product.data_01.split(";");
    label["title"] = data[0];
    label["bg"] = data[1];
    label["text"] = data[2];
    var style = "background:" + label["bg"] + "; color:" + label["text"];
    productObject
      .find("[data-inf-label-custom]")
      .attr({ style: style })
      .html(label["title"]);
  } else {
    productObject.find("[data-inf-label-custom]").attr({ style: "" }).html("");
  }

  // set current info
  productObject.attr({ "data-id": product.id, "data-url": product.url });
  productObject
    .find("[data-inf-url]")
    .attr({ href: product.url, title: product.fulltitle });
  productObject.find("[data-inf-label-discount]").html(discount);
  productObject
    .find("[data-inf-image]")
    .removeAttr("data-src")
    .removeAttr("data-srcset")
    .removeAttr("srcset")
    .removeClass("lazy lazy-blur")
    .attr("src", imageUrl);
  productObject
    .find("[data-inf-brand]")
    .html(product.brand ? product.brand.title : "");
  productObject
    .find("[data-inf-title]")
    .html(product.title)
    .attr({ href: product.url, title: product.title });
  productObject.find("[data-inf-price]").html(money(product.price.price));
  productObject
    .find("[data-inf-price-old]")
    .html(product.price.price_old ? money(product.price.price_old) : "");

  setTimeout(function () {
    $('.product[data-id="' + product.id + '"]').removeClass("inf-loading");
    $('.product[data-id="' + product.id + '"]')
      .find(".image-wrap .sec")
      .remove();
  }, 200);

  counter++;
}

function createMessage(data, type, btn, btnText) {
  var messages = $($.parseHTML(data)).find("#og-messages ul");
  var message = messages.first("li").text();
  var messageType = false;
  var icon = "";

  if (!message) {
    message = false;
  }

  if (messages.hasClass("error") || messages.hasClass("gui-error")) {
    messageType = "error";
    icon = "bx-x";
  } else if (messages.hasClass("success") || messages.hasClass("gui-success")) {
    messageType = "success";
    icon = "bx bx-check";
  } else if (messages.hasClass("info") || messages.hasClass("gui-info")) {
    messageType = "info";
    icon = "bxs-info-circle";
  }

  if (type == "add") {
    btn.html('<i class="bx bx-loader-alt bx-spin"></i>');
    setTimeout(function () {
      if (messageType == "success") {
        btn.html(btnText).addClass("success");
        if (template == "pages/cart.rain") {
          location.reload();
        } else {
          // $('.open-added-to-cart').trigger('click');
        }
      } else {
        btn.html(btnText).addClass("error");
      }
      setTimeout(function () {
        btn.removeClass("error success");
      }, 1000);
    }, 500);
  }

  var timestamp = new Date().getTime();
  if (message) {
    $(".live-message").attr("data-time", timestamp);
    $(".live-message .message")
      .removeClass("error success info")
      .addClass(messageType);
    $(".live-message .message .icon i").removeClass(
      "bx-x bx-check bxs-info-circle"
    );
    $(".live-message").removeClass("active");
    $(".live-message").addClass("active");
    $(".live-message .message .text ul li").html(message);
    $(".live-message .message .icon i").addClass(icon);

    var timeout = window.setTimeout(function () {
      $('.live-message[data-time="' + timestamp + '"]').removeClass("active");
    }, 4000);
  }
}

function headerFixed() {
  var header = $("#header");
  var headerHeight = header.find(".header-fixed-wrap").outerHeight();
  var initiateHeight = $(".topbar").length > 0 ? $(".topbar").outerHeight() : 0;
  var scrollTop = $(window).scrollTop();
  let mainHeaderHeight =
    $("#main-header").length > 0 ? $("#main-header").outerHeight() : 0;

  // if (scrollTop > 0) {
  //   header.addClass("scrolled");
  // } else {
  //   header.removeClass("scrolled");
  // }

  if (scrollTop >= initiateHeight) {
    // header.addClass("fixed");

    $("main").css("margin-top", -1 * headerHeight);
    $(".mobile-menu-container").css("top", mainHeaderHeight);
  } else {
    // header.removeClass("fixed");
    // $("main").css("padding-top", "0");
  }
}

function createUrl(url) {
  return window.origin + url;
}

function loadProduct(cur, index) {
  var tags = cur.attr("data-tags") ? cur.attr("data-tags").split(",") : [];
  var product_id = cur.attr("data-product-id")
    ? cur.attr("data-product-id")
    : false;
  var url = cur.data("url") + "?format=json";
  var ready = true;
  var timeOut = index * 100;

  if (ready) {
    if (!cur.hasClass("loaded")) {
      cur.addClass("loaded");
      setTimeout(function () {
        loadColorsByTags(
          tags,
          product_id,
          cur.find("[data-sm-color-swatches]"),
          "collection"
        );
      }, timeOut); // end timeout
    }
  }
}

function loadColorsByTags(tags, product_id, container, type) {
  $.each(tags, function (index, tag) {
    if (tag.startsWith("grouped_")) {
      var url = createUrl(
        "/search/suggest.json?q=" +
          tag +
          "&resources[type]=product&resources[options][fields]=tag,variants.title"
      );
      $.get(url, function (data) {
        var colors = [];
        $.each(data.resources.results.products, function (pr_index, product) {
          if (product.tags.includes(tag)) {
            var url = product.url.split("?")[0] + ".json";
            $.get(url, function (data) {
              var product = data.product;
              $.each(product.options, function (index, option) {
                if (option.name.toLowerCase() == "kleur") {
                  $.each(option.values, function (index, value) {
                    if (type == "collection") {
                      container.append(
                        '<li style="order:' +
                          pr_index +
                          '" ' +
                          (product_id == product.id ? "active" : "") +
                          '"><a href="/products/' +
                          product.handle +
                          '"><img src="' +
                          createImage(product.images[0].src, "70x100") +
                          '"></a></li>'
                      );
                    } else if (type == "product") {
                      if (product_id == product.id) {
                        product["active"] = true;
                      } else {
                        product["active"] = false;
                      }
                      product.order = pr_index;
                      var colors = app.product_colors ? app.product_colors : [];
                      colors.push(product);
                      app.product_colors = colors;
                      app.$forceUpdate();
                    }
                  });
                }
              });
            });
          }
        });
      }).done(function () {});
    }
  });
}

function setFeaturedBlogArticles(articles) {
  var new_articles = [];
  var a_index = 0;
  $.each(articles, function (index, article) {
    a_index++;
    var thisDate = Date.parse(article.date);
    if (a_index < 3) {
      new_articles[thisDate] = article;
    }
  });

  return new_articles;
}

function searchCategories(query, categories) {
  var foundCategories = {};
  var catCount = 0;
  $.each(categories, function (index, category) {
    var searchCat = query.toLowerCase().replace(" ", "").replace("+", "");
    var findCat = category.title.toLowerCase().replace(" ", "");
    searchCat = searchCat.replace(new RegExp("\\+", "g"), "");
    findCat = findCat.replace(/ /g, "");

    if (findCat.indexOf(searchCat) >= 0) {
      catCount++;
      foundCategories[category.id] = {
        title: category.title,
        url: category.url,
        count: category.count
      };
    }
    if (category.subs) {
      var cat_up = categories[category.id];
      $.each(category.subs, function (index, category) {
        var findCat = category.title.toLowerCase().replace(" ", "");
        findCat = findCat.replace(/ /g, "");

        if (findCat.indexOf(searchCat) >= 0) {
          catCount++;
          foundCategories[category.id] = {
            title: category.title,
            url: category.url,
            count: category.count,
            path: cat_up["title"]
          };
        }

        if (category.subs) {
          var newCatUp = cat_up["title"] + " / " + category.title;
          $.each(category.subs, function (index, category) {
            var findCat = category.title.toLowerCase().replace(" ", "");
            findCat = findCat.replace(/ /g, "");
            if (findCat.indexOf(searchCat) >= 0) {
              catCount++;
              foundCategories[category.id] = {
                title: category.title,
                url: category.url,
                count: category.count,
                path: newCatUp
              };
            }
          });
        }
      });
    }
  });

  foundCategories = catCount > 0 ? foundCategories : false;
  return foundCategories;
}

function checkRequiredFields(requiredFields) {
  var error = false;

  $.each(requiredFields, function (key, field) {
    if ($(this).val() == "" || $(this).val() == " ") {
      errorField($(this), "add");
      error = true;
    } else {
      errorField($(this), "remove");
    }

    var name = $(this).attr("name");
    if (name == "email" && !validateEmail($(this).val())) {
      errorField($(this), "add");
      error = true;
    } else if (name == "email" && validateEmail($(this).val())) {
      errorField($(this), "remove");
    }
  });

  return error;
}

function errorField(cur, type) {
  var name = cur.attr("name");

  if (type == "add" && !cur.closest(".inputs__wrap").hasClass("error")) {
    cur
      .closest(".inputs__item")
      .append(
        '<div class="inputs__message inputs__message--error">This field is required.</div>'
      );
    cur
      .closest(".inputs__wrap")
      .addClass("error")
      .append('<i class="bx bx-x"></i>');
  } else if (type == "remove") {
    cur.closest(".inputs__item").find(".inputs__message").remove();
    cur.closest(".inputs__wrap").removeClass("error").find("i").remove();
  }
}

function validateEmail(email) {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function toggleSubMenu(linkTitle) {
  document.getElementById(`sub-${linkTitle}`).classList.toggle("active");
}

function applyColumns() {
  const params = new URLSearchParams(document.location.search);

  if (!params.get("columns")) {
    return;
  }

  const paramColumn = parseInt(params.get("columns"));

  // Update Vue with correct column values
  app.collection_columns = paramColumn;

  // Add bootstrap class to grid
  let bootstrapPrefix = "";

  if (paramColumn < 3) {
    bootstrapPrefix = "col-";
  } else {
    bootstrapPrefix = "col-lg-";
  }

  let bootstrapClass = bootstrapPrefix + 12 / paramColumn;
  const allProducts = document.querySelectorAll(".product");

  allProducts.forEach((product) => {
    product.classList.add(bootstrapClass);
  });
}

// Collection top columns selector
const url = window.location;
const urlParams = new URLSearchParams(url.search);
const columns = urlParams.get("columns");

switch (columns) {
  case "1":
    $("#sm-one-columns").attr("checked", true);
    $("#sm-one-columns__label").addClass("active");
    break;
  case "2":
    $("#sm-two-columns").attr("checked", true);
    $("#sm-two-columns__label").addClass("active");
    break;
  case "3":
    $("#sm-three-columns").attr("checked", true);
    $("#sm-three-columns__label").addClass("active");
    break;
  case "4":
    $("#sm-four-columns").attr("checked", true);
    $("#sm-four-columns__label").addClass("active");
    break
}

function updateColumns(e) {
  urlParams.set("columns", e.target.value);
  url.search = urlParams.toString();
}
